// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Mky6q","num":"styles_num__37t9u"};